import FroalaEditor from 'froala-editor'

const config = {
  enter: FroalaEditor.ENTER_BR,
  listAdvancedTypes: false,
  quickInsertEnabled: false,
  toolbarButtons: {
    moreText: {
      buttons: [
        'bold',
        'italic',
        'underline',
        '|',
        'formatUL',
        'formatOL',
      ],
      buttonsVisible: 11
    },
    moreText2: {
      buttons: [
      ],
      buttonsVisible: 11
    },
    moreMisc: {
      buttons: [],
      align: 'right',
      buttonsVisible: 3
    }
  }
}

export default config
